module.exports = __webpack_public_path__ + "img/2.a5552b23.png";